module.exports = __webpack_public_path__ + "static/media/logout.d88189f5.svg";